import React, { useState } from 'react';
import { TextButton, DropDownMenu } from '@shape-ds/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { notificationOptions } from './NotificationHelper';
import './NotificationMenuOptions.scss';

const NotificationMenuOptions: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TextButton
        onClick={() => setOpen(true)}
        data-testid="edit-button"
        className="notifications-button notifications-button-edit"
      >
        <MoreVertIcon />
      </TextButton>
      {open && (
        <DropDownMenu
          dropDownOptions={notificationOptions(setOpen)}
          className="notification-menu-options"
          onMouseLeave={() => setOpen(false)}
          onClickAway={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default NotificationMenuOptions;
